import React, { Component } from "react";
import { Fade, Slide } from "react-awesome-reveal";

class Contact extends Component {
  

  render() {
    if (!this.props.data) return null;

    

    /*const name = this.props.data.name;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const message = this.props.data.contactmessage;*/

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get In Touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">Write a message to get in contact with me</p>
            </div>
          </div>
        </Fade>

        <div className="row">
      {/*  <Slide left duration={1000}> */}
            <div className="eight columns">

              <form action="/send-email" method="post" id="contactForm" name="contactForm" onSubmit={this.handleSubmit}>
                <fieldset>
                  <div>
                    <label htmlFor="contactName">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      size="35"
                      id="contactName"
                      name="contactName"
                      
                    />
                  </div>

                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      size="35"
                      id="contactEmail"
                      name="contactEmail"
                      />
                  </div>

                  <div>
                    <label htmlFor="contactSubject">Subject</label>
                    <input
                      type="text"
                      size="35"
                      id="contactSubject"
                      name="contactSubject"
                      
                    />
                  </div>

                  <div>
                    <label htmlFor="contactMessage">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      id="contactMessage"
                      name="contactMessage"
                      
                    ></textarea>
                  </div>

                  <div>
                    <button className="submit">Submit</button>
                    <span id="image-loader">
                      <img alt="ima" src="images/loader.gif" />
                    </span>
                  </div>
                </fieldset>
              </form>

            </div>
       {/*   </Slide> */}

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Address and Phone</h4>
                <p className="address">
                  SAM_SNY
                  <br />
                  4 ikot oko Idio <br />
                  Uyo, Akwa-Ibom-State 502104<br />
                  <span>09167380934</span>
                </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Latest Tweets</h4>
                <ul id="twitter">
                  <li>
                    <span>
                    Working on a new project and loving the simplicity of #ReactJS. Component-based development makes everything so modular and clean! 🔧
                      <a href="https://twitter.com/sam_sny1/status/1722184429395652683">https://twitter.com/sam_sny1/status/1722184429395652683</a>
                    </span>
                    <b>
                      <a href="./">November 8th</a>
                    </b>
                  </li>
                  <li>
                    <span>
                    Web accessibility matters! Don't forget to test your sites with screen readers and follow WCAG guidelines. Everyone deserves a great online experience. ♿️
                      <a href="https://twitter.com/sam_sny1/status/1722185121879433706">https://twitter.com/sam_sny1/status/1722185121879433706</a>
                    </span>
                    <b>
                      <a href="./">November 8th</a>
                    </b>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
